<template>
  <div id="content-container" v-if="item">
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="钻井详情">
      </el-page-header>
      <el-descriptions title="">
        <el-descriptions-item label="井号">{{
          item.well_number
        }}</el-descriptions-item>
        <el-descriptions-item label="井队">{{
          item.well_team
        }}</el-descriptions-item>
        <el-descriptions-item label="区块">{{
          item.well_block
        }}</el-descriptions-item>
        <el-descriptions-item label="所属基地">{{
          item.base.name
        }}</el-descriptions-item>
        <el-descriptions-item label="服务人员">{{
          item.service_staff_names.join('、')
        }}</el-descriptions-item>
        <el-descriptions-item label="施工类型">{{
          item.construction || '-'
        }}</el-descriptions-item>
        <el-descriptions-item label="开始服务日期">{{
          item.start_serve_date || '无'
        }}</el-descriptions-item>
        <el-descriptions-item label="完工日期">{{
          item.end_serve_date || '无'
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <ItemStatus :status="item.status" model="drillWell"></ItemStatus>
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          {{ item.remark }}
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div class="panel" style="position: relative">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="数据记录" name="tab1">
          <ProductRecords :wellId="item.id" ref="tab1"></ProductRecords>
        </el-tab-pane>
        <el-tab-pane label="物资出入记录" name="tab2">
          <WellPeriods :category="2" :wellid="item.id"></WellPeriods>
        </el-tab-pane>
        <el-tab-pane label="待接收物资" name="tab3">
          <SupplyIndex :wellid="item.id"></SupplyIndex>
        </el-tab-pane>
        <el-tab-pane label="仪器串" name="tab4" v-if="hasAuth('productGroup')">
          <ProductGroup :wellid="item.id" @select="handleSelect"></ProductGroup>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { drillWellDetail } from '@/service/getData'
import ProductRecords from './ProductRecords.vue'
import WellPeriods from './well_period/index.vue'
import SupplyIndex from './supply/index.vue'
import ProductGroup from './product_group/index'

export default {
  components: {
    ProductRecords,
    WellPeriods,
    SupplyIndex,
    ProductGroup,
  },
  data() {
    return {
      item: null,
      activeTab: 'tab1',
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await drillWellDetail(this.$route.params.id)
      if (res.status != 0) return
      this.item = res.data
    },
    editItem() {
      this.model = this.clone(this.item)
      this.model.custom_params = this.copyCustomParam(
        this.item.template.custom_params,
        this.item.custom_params,
      )
      this.formerVisible = true
    },
    updatedCallback(data) {
      this.item = data
    },
    addUsedRecord(type) {
      this.record = {
        item_id: this.item.id,
        product_id: this.item.product.id,
        used_hour: 0,
        used_extra: [],
        category: type,
        used_date: '',
        imgs: [],
        remark: '',
      }

      if (type == 5) {
        this.record.used_extra = [
          { key: 'block', value: '', label: '使用区块' },
          { key: 'well_team_number', value: '', label: '井队号' },
          { key: 'well_number', value: '', label: '井号' },
        ]
      }
      this.recordFormerVisible = true
    },
    recordCreated(item) {
      this.item.id = 0
      this.getData()
      this.activeTab = item.category == 6 ? 'tab2' : 'tab1'
    },

    handleExport() {
      this.downloading = true
      this.$refs[this.activeTab].handleExport()
    },

    handleSelect(e) {
      this.activeTab = 'tab1'
      this.$refs[this.activeTab].handleAdd(e)
    },
  },
}
</script>

<style>
.el-timeline-item {
  padding-bottom: 10px;
}

.export-btn {
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 10;
}
</style>
